import { useQuery } from '@tanstack/react-query';
import { getUser } from '../user.service';

interface UseGetUser {
  userId: string | undefined | null;
}

const useGetUser = ({ userId }: UseGetUser) => {
  return useQuery({
    queryKey: ['userads', userId],
    queryFn: () => getUser(userId),
    enabled: !!userId,
  });
};

export default useGetUser;
